import * as React from 'react';
import { SVGProps } from 'react';

const IconQuoteSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 4H2v3h2L3 9h1l1-2V4ZM10 4H7v3h2L8 9h1l1-2V4Z" />
  </svg>
);
export default IconQuoteSizeXs;
